import { TooltipProps, Box, Text } from '@chakra-ui/react';
import { trioUITheme } from '@/styles/theme';
import * as Styles from './ChartHeader.styles';
import Tooltip from '../Tooltip';

type FilterOption = {
  isActived?: boolean;
  label: string;
  value: string;
};
export type ChartHeaderProps = {
  onSelectFilter?: (value: string) => void;
  title: string;
  tooltipMessage: string;
  filterOptions?: FilterOption[];
  tooltipOptions?: Partial<TooltipProps>;
  withDateFilter?: boolean;
  selectedDate?: string;
};

const ChartHeader = ({
  title,
  tooltipMessage,
  filterOptions = [],
  onSelectFilter,
  tooltipOptions,
  withDateFilter = false,
  selectedDate = '',
  ...props
}: ChartHeaderProps): JSX.Element => {
  return (
    <Styles.Header data-testid="chart-header" {...props}>
      <Styles.TitleArea>
        <Styles.Title>{title}</Styles.Title>
        <Tooltip placement="bottom" label={tooltipMessage} {...tooltipOptions} />
      </Styles.TitleArea>
      <div>
        {filterOptions?.map((filter, index) => {
          return (
            <Styles.TopBarLink
              key={`${filter.label}-${filter.value}`}
              id={`bt-filter${index}`}
              data-testid={`bt-filter${index}`}
              onClick={() => (onSelectFilter ? onSelectFilter(filter.value) : null)}
              isActived={filter.isActived}
            >
              {filter.label}
            </Styles.TopBarLink>
          );
        })}

        {withDateFilter && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Text mr="8px" fontSize={14} color={trioUITheme.colors['neutral-90']}>
              on
            </Text>
            <Styles.InputDate
              backgroundColor={trioUITheme.colors['neutral-40']}
              color={trioUITheme.colors['neutral-90']}
              size="sm"
              border={0}
              borderRadius={4}
              type="month"
              value={selectedDate}
              onChange={(e) => (onSelectFilter ? onSelectFilter(e.target.value) : null)}
            />
          </Box>
        )}
      </div>
    </Styles.Header>
  );
};

export default ChartHeader;
